module.exports = __webpack_public_path__ + "static/scale-model-of-moccasin-lake-nature-park-in-clearwater-florida-f9e0ae4c60fd658a07fcdb6b7ba528de.png";